import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import img1 from '../../../Assets/b2b2c-scrollview-1.svg';
import img2 from '../../../Assets/b2b2c-scrollview-2.svg';
import img3 from '../../../Assets/b2b2c-scrollview-3.svg';
import img4 from '../../../Assets/b2b2c-scrollview-4.svg';
import img5 from '../../../Assets/b2b2c-scrollview-5.svg';

const ScrollContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const ScrollContent = styled.div`
    display: inline-flex;
    gap: 10px;
    padding: 20px 0;
`;

const ScrollImage = styled.img`
    width: 312.5px;
    height: 312.5px;
    border-radius: 32px;
    opacity: 1;
    object-fit: cover;
    flex-shrink: 0;
    transform: rotate(0deg);
`;

const ImageHorizontalView = () => {
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        let scrollAmount = 0;
        const scrollSpeed = 1;
        const delay = 2000;

        const autoScroll = () => {
            if (scrollContainer) {
                scrollAmount += scrollSpeed;
                scrollContainer.scrollLeft = scrollAmount;

                if (scrollAmount >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
                    scrollAmount = 0;
                }
            }
        };

        const timeoutId = setTimeout(() => {
            const intervalId = setInterval(autoScroll, 30);
            return () => clearInterval(intervalId);
        }, delay);

        return () => clearTimeout(timeoutId);
    }, []);

    const images = [img1, img2, img3, img4, img5];

    return (
        <ScrollContainer ref={scrollContainerRef}>
            <ScrollContent>
                {images.map((img, index) => (
                    <ScrollImage
                        key={index}
                        src={img}
                        alt={`Slide ${index + 1}`}
                    />
                ))}
                {images.map((img, index) => (
                    <ScrollImage
                        key={`duplicate-${index}`}
                        src={img}
                        alt={`Slide duplicate ${index + 1}`}
                    />
                ))}
            </ScrollContent>
        </ScrollContainer>
    );
};

export default ImageHorizontalView;
